import { API_BASE_URL } from "./api";

const SUPPORTED_PROVIDERS = ["google", "github", "facebook"];

export function getOAuthProviderLabel(provider) {
  const normalizedProvider = provider?.toLowerCase();

  if (!SUPPORTED_PROVIDERS.includes(normalizedProvider)) {
    throw new Error(
      `Unsupported OAuth provider: ${provider || "unknown"}. Supported providers are: ${SUPPORTED_PROVIDERS.join(", ")}.`,
    );
  }

  if (normalizedProvider === "google") return "Google";
  if (normalizedProvider === "github") return "GitHub";
  return "Facebook";
}

export function startOAuth(provider) {
  const normalizedProvider = provider?.toLowerCase();

  if (!SUPPORTED_PROVIDERS.includes(normalizedProvider)) {
    throw new Error(
      `Unsupported OAuth provider: ${provider || "unknown"}. Supported providers are: ${SUPPORTED_PROVIDERS.join(", ")}.`,
    );
  }

  const oauthUrl = `${API_BASE_URL}/auth/oauth/${normalizedProvider}`;
  window.location.assign(oauthUrl);
}
